---
title: 'Step 5: Configure the Collector'
install_track_title: Installation Guide (Aiven)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import imgAivenDbSettings from './aiven-db-settings.png'

export const ImgAivenDbSettings = () => <img alt="Aiven database settings screenshot" src={imgAivenDbSettings} />

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'

export const APIKeyInstructions = ({ apiKey }) => {
  return apiKey ? (
    <React.Fragment>
      The <code>PGA_API_KEY</code> for the current organization is{" "}
      <code>{apiKey}</code>
    </React.Fragment>
  ) : (
    <React.Fragment>
      The <code>PGA_API_KEY</code> can be found in the pganalyze Settings page
      for your organization, under the API Access tab
    </React.Fragment>
  );
};

export const CollectorDotEnv = ({ apiKey }) => {
  return (
    <CodeBlock>
      {`PGA_API_KEY=${apiKey ?? 'your_pga_organization_api_key'}
DB_HOST=your_database_host
DB_PORT=your_database_port
DB_NAME=your_database_name
DB_USERNAME=your_monitoring_user
DB_PASSWORD=your_monitoring_user_password`}
    </CodeBlock>
  );
};

Create your configuration file (e.g. named `pganalyze_collector.env`) with environment variables like this:

<CollectorDotEnv apiKey={props.apiKey} />

Fill in the values from the info in your Aiven console:

<ImgAivenDbSettings />

1. <APIKeyInstructions apiKey={props.apiKey} />
2. The `DB_HOST` is the hostname of your PostgreSQL instance (`example.aivencloud.com` above)
3. The `DB_PORT` is the port your PostgreSQL server is running on (`12448` above)
4. The `DB_NAME` is the database you want to monitor (`defaultdb` above--make
   sure this is the same database where you created the `pg_stat_statements`
   extension in Step 2)
5. The `DB_USERNAME` and `DB_PASSWORD` should be the credentials of the monitoring user we created in Step 1

## Test snapshot

Then run the following:

<CodeBlock language="bash">
{`docker run --env-file pganalyze_collector.env quay.io/pganalyze/collector:stable test`}
</CodeBlock>

<PublicLastStepLogInsightsLink />
